module.exports = __webpack_public_path__ + "img/IMG_0057_L_Wood_MockedUp.029c6986.jpg";